import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import { MuiThemeProvider } from '@material-ui/core/styles'
import StyleSheet from 'styles'
import { SectionLoader } from './SectionLoader'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { baseTheme, darkTheme } from 'styles'

let PDF = null

export class PdfAgreement extends Component {

  static propTypes = {
    pdfPath: PropTypes.string.isRequired,
    onAgree: PropTypes.func.isRequired,
    onDisagree: PropTypes.func.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      ...this.state,
      loaded: false,
      numberOfPages: 1,
    }
    import('react-pdf-js').then(result => {
      PDF = result.default
      this.forceUpdate()
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.open && !this.props.open) {
      this.setState({
        loaded: false,
        numberOfPages: 1,
      })
    }
  }

  static defaultProps = {
    theme: 'light'
  }

  handleDisagree = () => {
    this.props.onDisagree()
  }

  handleAgree = () => {
    this.props.onAgree()
  }

  onDocumentComplete = (numberOfPages, pdf) => {
    this.setState({
      numberOfPages,
      loaded: true,
    });
  }

  onPageComplete = (currentPage, page) => {
    this.setState({ currentPage });
  }

  render() {
    if(!PDF)
      return false
    return (
      <div>
        <MuiThemeProvider theme={this.props.theme === 'light' ? baseTheme : darkTheme}>
          <Dialog open={this.props.open} maxWidth="md">
            <DialogTitle>
              {this.props.title}
            </DialogTitle>
            <DialogContent className={styles.content}>
              {new Array(this.state.numberOfPages).fill(1).map((_, i) => i + 1).map(page =>
                <div key={page} className={styles.pageContainer}>
                  <PDF className={styles.pdf}
                       file={this.props.pdfPath}
                       page={page}
                       onDocumentComplete={this.onDocumentComplete}
                       onPageComplete={this.onPageComplete}
                       loading={<div style={{width: 200, height: 200}}><SectionLoader /></div>}/>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDisagree} color="primary">
                Disagree
              </Button>
              <Button onClick={this.handleAgree} color="primary" disabled={!this.state.loaded}>
                Agree
              </Button>
            </DialogActions>
          </Dialog>
        </MuiThemeProvider>
      </div>
    );
  }
}

export const styles = StyleSheet({
  pdf: {
    width: '100% !important',
    height: 'auto !important',
  },
  pageContainer: {
    '&:last-child': {
      marginBottom: -3,
      overflow: 'hidden'
    }
  },
  content: {
    padding: 0,
    backgroundColor: '#CCC'
  }
})